<template>
  <div class="hall-page">
    <div class="page-bg"></div>

    <!-- 顶部 -->
    <div class="top-section">
      <div class="top-glow glow-1"></div>
      <div class="top-glow glow-2"></div>

      <van-nav-bar
        class="nav-bar"
        :title="$t('reservation.hall')"
      >
        <template #left>
          <div class="back-btn" @click="back()">
            <van-icon name="arrow-left" color="#fff" />
          </div>
        </template>
      </van-nav-bar>

      <div class="top-desc-card">
        <div class="top-title">{{ $t('reservation.hall') }}</div>
        <div class="top-subtitle">Reservation Hall</div>
      </div>
    </div>

    <!-- 主体 -->
    <div class="main-panel">
      <!-- 左侧分类 -->
      <div class="left-panel">
        <div class="left-inner">
          <van-sidebar @change="onChange" v-model="activeKey" class="custom-sidebar">
            <van-sidebar-item :title="$t('index.all')" />
            <van-sidebar-item
              v-for="(v, key) in lotteryitem"
              :key="key"
              :title="v.name"
            />
          </van-sidebar>
        </div>
      </div>

      <!-- 右侧列表 -->
      <div class="right-panel">
        <van-pull-refresh
          pulling-text="Sao chép nhanh quy trình thả xuống"
          loosing-text="Bản sao nhắc nhở của quá trình phát hành"
          loading-text="Loading"
          success-text="Refresh successful"
          class="list-wrapper"
          v-model="isLoading"
          @refresh="onRefresh"
        >
          <div class="game-grid">
            <div
              class="game-card"
              @click="toLottery(v.key, v.id)"
              v-for="(v, key) in gameitem"
              :key="key"
            >
              <div class="game-card-inner">
                <van-image class="game-item-img" :src="v.ico">
                  <template v-slot:loading>
                    <van-loading type="circular" />
                  </template>
                </van-image>

                <div class="game-content">
                  <div class="game-name">{{ v.name }}</div>
                  <div class="game-desc">{{ v.desc }}</div>
                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';

export default {
  data() {
    return {
      gameitem: [{}, {}, {}, {}],
      lotteryitem: [{}, {}, {}, {}],
      isLoading: false,
      activeKey: 0
    };
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        Toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },

    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' });
      } else {
        this.$router.push({ path: '/Lottery?key=' + key + "&id=" + id });
      }
    },

    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res => {
        this.gameitem = res.data || [];
      });
    },

    onChange(index) {
      this.$http({
        method: 'get',
        data: { class: index },
        url: 'lottery_list'
      }).then(res => {
        this.gameitem = res.data || [];
      });
    },

    back() {
      return window.history.back();
    },

    getLotteryItem() {
      this.$http({
        method: 'get',
        url: 'lottery_class'
      }).then(res => {
        this.lotteryitem = res.data || [];
      });
    }
  },
  created() {
    this.getGameItem();
    this.getLotteryItem();
  }
};
</script>

<style lang="less" scoped>
.hall-page {
  position: relative;
  min-height: 100vh;
  padding-bottom: 96px;
  background:
    radial-gradient(circle at top, rgba(255, 221, 232, 0.9) 0%, rgba(255, 244, 247, 0.96) 28%, #fff 68%);
  overflow: hidden;
}

.page-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 280px;
  background: linear-gradient(135deg, #ff95ba 0%, #ff6f9e 38%, #f04d87 70%, #d73b88 100%);
  border-radius: 0 0 34px 34px;
  box-shadow: 0 12px 32px rgba(227, 92, 138, 0.18);
  pointer-events: none;
  z-index: 0;
}

/* 顶部 */
.top-section {
  position: relative;
  z-index: 2;
  padding-bottom: 18px;
  overflow: hidden;
}

.top-glow {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  pointer-events: none;
}

.glow-1 {
  width: 180px;
  height: 180px;
  right: -40px;
  top: -30px;
}

.glow-2 {
  width: 120px;
  height: 120px;
  left: -20px;
  top: 120px;
  background: rgba(255, 255, 255, 0.08);
}

.nav-bar {
  position: relative;
  z-index: 3;
  background: transparent !important;
}

::v-deep .van-nav-bar {
  background: transparent !important;
}

::v-deep .van-nav-bar::after {
  border: none !important;
}

::v-deep .van-nav-bar__content {
  height: 92px;
}

::v-deep .van-nav-bar__title {
  color: #fff;
  font-size: 34px;
  font-weight: 700;
}

.back-btn {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(8px);
}

::v-deep .back-btn .van-icon {
  font-size: 28px !important;
}

.top-desc-card {
  position: relative;
  z-index: 3;
  margin: 8px 20px 0;
  padding: 20px 22px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(14px);
  box-shadow: 0 14px 30px rgba(162, 30, 85, 0.16);
}

.top-title {
  font-size: 34px;
  line-height: 1.2;
  font-weight: 700;
  color: #fff;
}

.top-subtitle {
  margin-top: 10px;
  font-size: 22px;
  color: rgba(255, 255, 255, 0.82);
}

/* 主体 */
.main-panel {
  position: relative;
  z-index: 4;
  display: flex;
  height: calc(100vh - 190px);
  padding: 0 12px 12px;
  gap: 12px;
  box-sizing: border-box;
}

/* 左侧 */
.left-panel {
  width: 26%;
  min-width: 94px;
  max-width: 120px;
  height: 100%;
}

.left-inner {
  height: 100%;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 24px;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(213, 117, 150, 0.1);
  border: 1px solid rgba(255, 206, 222, 0.52);
  -webkit-overflow-scrolling: touch;
}

.custom-sidebar {
  width: 100%;
  background: transparent;
}

::v-deep .van-sidebar {
  width: 100%;
  background: transparent;
}

::v-deep .van-sidebar-item {
  position: relative;
  padding: 22px 10px;
  background: transparent;
  text-align: center;
  font-size: 24px;
  color: #936978;
  font-weight: 600;
  line-height: 1.3;
}

::v-deep .van-sidebar-item__text {
  display: block;
  word-break: break-word;
}

::v-deep .van-sidebar-item--select {
  color: #ec5f92;
  background: linear-gradient(180deg, rgba(255, 240, 245, 0.92) 0%, rgba(255, 250, 252, 0.98) 100%);
  font-weight: 700;
}

::v-deep .van-sidebar-item--select::before {
  left: 8px;
  width: 8px;
  height: 42%;
  background: linear-gradient(180deg, #ff8cb3 0%, #f45e93 100%);
  border-radius: 999px;
}

/* 右侧 */
.right-panel {
  flex: 1;
  height: 100%;
  min-width: 0;
}

.list-wrapper {
  height: 100%;
  overflow-y: auto;
  padding-right: 2px;
  -webkit-overflow-scrolling: touch;
}

.game-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding-bottom: 20px;
}

.game-card {
  min-width: 0;
}

.game-card-inner {
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 10px 24px rgba(213, 117, 150, 0.1);
  border: 1px solid rgba(255, 206, 222, 0.5);
  padding: 16px 12px 18px;
  min-height: 230px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.2s ease;
}

.game-card:active .game-card-inner {
  transform: scale(0.98);
  background: linear-gradient(180deg, #fff7fa 0%, #fff 100%);
}

.game-item-img {
  width: 112px;
  height: 112px;
  flex-shrink: 0;
}

::v-deep .game-item-img .van-image__img {
  border-radius: 26px;
}

.game-content {
  width: 100%;
  margin-top: 14px;
  text-align: center;
}

.game-name {
  font-size: 24px;
  line-height: 1.35;
  color: #ca4f7f;
  font-weight: 700;
  word-break: break-word;
}

.game-desc {
  margin-top: 8px;
  font-size: 18px;
  line-height: 1.45;
  color: #8b6b78;
  word-break: break-word;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #8e5870;
  font-size: 24px;
}

/* 小屏优化 */
@media (max-width: 375px) {
  .main-panel {
    height: calc(100vh - 172px);
    padding: 0 10px 10px;
    gap: 10px;
  }

  ::v-deep .van-nav-bar__content {
    height: 82px;
  }

  ::v-deep .van-nav-bar__title {
    font-size: 30px;
  }

  .back-btn {
    width: 46px;
    height: 46px;
  }

  .top-desc-card {
    margin: 6px 14px 0;
    padding: 18px 18px;
  }

  .top-title {
    font-size: 30px;
  }

  .top-subtitle {
    font-size: 20px;
  }

  .left-panel {
    min-width: 84px;
    max-width: 100px;
  }

  ::v-deep .van-sidebar-item {
    padding: 18px 8px;
    font-size: 20px;
  }

  .game-grid {
    gap: 10px;
  }

  .game-card-inner {
    min-height: 200px;
    padding: 14px 10px 16px;
    border-radius: 20px;
  }

  .game-item-img {
    width: 92px;
    height: 92px;
  }

  .game-name {
    font-size: 20px;
  }

  .game-desc {
    font-size: 16px;
  }
}

/* 超小屏 */
@media (max-width: 340px) {
  .main-panel {
    gap: 8px;
  }

  .left-panel {
    min-width: 78px;
    max-width: 90px;
  }

  ::v-deep .van-sidebar-item {
    padding: 16px 6px;
    font-size: 18px;
  }

  .game-card-inner {
    min-height: 184px;
    padding: 12px 8px 14px;
  }

  .game-item-img {
    width: 82px;
    height: 82px;
  }

  .game-name {
    font-size: 18px;
  }

  .game-desc {
    font-size: 14px;
  }
}
</style>

<style lang="less" scoped>
.hall-page {
	min-height: 100vh;
	padding-bottom: calc(88PX + env(safe-area-inset-bottom));
	background:
		radial-gradient(120% 42% at 50% -8%, rgba(148, 98, 36, 0.32), transparent 56%),
		radial-gradient(70% 30% at 100% 18%, rgba(112, 36, 72, 0.2), transparent 62%),
		linear-gradient(180deg, #1a140f 0%, #100d13 36%, #0c0a10 100%);
	color: #efe6d6;
	font-family: "Plus Jakarta Sans", "PingFang SC", "Microsoft YaHei", sans-serif;
	overflow-x: hidden;
}

.page-bg,
.top-glow {
	display: none;
}

.top-section {
	padding-bottom: 4PX;
	background: linear-gradient(180deg, rgba(28, 20, 14, 0.72), rgba(28, 20, 14, 0));
}

.nav-bar,
::v-deep .van-nav-bar {
	background: transparent !important;
}

::v-deep .van-nav-bar__content {
	height: 52PX;
}

::v-deep .van-nav-bar__title {
	color: #f3d27a !important;
	font-size: 18PX !important;
	font-weight: 650;
}

.back-btn {
	width: 32PX;
	height: 32PX;
	border-radius: 8PX;
	background: rgba(255, 244, 214, 0.08);
	border: 1PX solid rgba(212, 175, 55, 0.28);
}

::v-deep .back-btn .van-icon {
	font-size: 16PX !important;
	color: #f3d27a !important;
}

.top-desc-card {
	margin: 2PX 16PX 12PX;
	padding: 12PX 14PX;
	border: 1PX solid rgba(244, 216, 131, 0.16);
	border-radius: 8PX;
	background: linear-gradient(180deg, rgba(255, 244, 214, 0.08), rgba(18, 14, 22, 0.4));
	box-shadow: 0 10PX 22PX rgba(0, 0, 0, 0.24), inset 0 1PX 0 rgba(255, 236, 196, 0.1);
}

.top-title {
	color: #f9eab8;
	font-size: 16PX;
	font-weight: 650;
}

.top-subtitle {
	margin-top: 4PX;
	color: rgba(249, 234, 184, 0.62);
	font-size: 12PX;
}

.main-panel {
	display: flex;
	align-items: flex-start;
	height: auto;
	gap: 10PX;
	padding: 0 12PX 12PX;
}

.left-panel {
	width: 88PX;
	min-width: 88PX;
	max-width: 88PX;
	height: auto;
}

.left-inner {
	height: auto;
	max-height: calc(100vh - 220PX);
	border: 1PX solid rgba(244, 216, 131, 0.16);
	border-radius: 8PX;
	background: linear-gradient(180deg, rgba(255, 244, 214, 0.06), rgba(18, 14, 22, 0.45));
	box-shadow: none;
}

::v-deep .van-sidebar-item {
	padding: 14PX 6PX;
	background: transparent;
	color: #b5aa96;
	font-size: 12PX;
	font-weight: 600;
}

::v-deep .van-sidebar-item--select {
	background: rgba(243, 210, 122, 0.1);
	color: #f3d27a;
}

::v-deep .van-sidebar-item--select::before {
	left: 4PX;
	width: 3PX;
	background: linear-gradient(180deg, #fff1c8, #c9963a);
	border-radius: 99PX;
}

.right-panel,
.list-wrapper {
	height: auto;
	overflow: visible;
}

.game-grid {
	gap: 10PX;
}

.game-card-inner {
	min-height: 0;
	padding: 12PX 8PX 10PX;
	border: 1PX solid rgba(244, 216, 131, 0.16);
	border-radius: 8PX;
	background: linear-gradient(180deg, rgba(255, 248, 230, 0.08), rgba(255, 255, 255, 0.03));
	box-shadow: inset 0 1PX 0 rgba(255, 255, 255, 0.05);
}

.game-item-img {
	width: 64PX;
	height: 64PX;
}

::v-deep .game-item-img .van-image__img {
	border-radius: 8PX;
	object-fit: cover;
}

.game-name {
	color: #f6e7c0;
	font-size: 12PX;
}

.game-desc {
	color: rgba(255, 255, 255, 0.55);
	font-size: 11PX;
}

::v-deep .van-pull-refresh__head,
::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
	color: rgba(249, 234, 184, 0.7);
	font-size: 12PX;
}
</style>
